// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"155":"Swiper","359":"EmbededVideo","737":"Snap","945":"Video"}[chunkId] + "-" + {"155":"ffbef5b542c84364","359":"38a2e38f15fc2289","737":"9183e8bd5159da15","945":"44b358daa7c96020"}[chunkId] + ".js";
};